module.exports = __webpack_public_path__ + "img/5.acd8edd5.png";